import View from './FormRealm';
import enhancer from './FormRealm.enhancer';

const FormRealm = enhancer(View);

export default FormRealm;
